import { ProductSectionViewModel } from '../../../../product-menu/building-blocks/menu-section/product-section/product-section-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class SpotlightProductSectionViewModel extends ProductSectionViewModel {}
